import React, {useState, useEffect} from 'react'

function Fill_in({setPay, setStk, setFillin, setDoc, setBackid, setFrontid,  uniq, ms}) {

  
    const [name, setName] = useState()
    const [course, setCourse] = useState()
    const [inst, setInst] = useState()
    const [phone, setPhone] = useState()
    const [altphone, setAltphone] = useState()
    const [type, setType] = useState('')

     
    
    useEffect(()=>{
      setType('intern')
     
    },[type])
    const submit = () =>{
  
      
     
  
      if(name && course && inst && phone && altphone)
      {
       
        const loginData = {
          name,
          course,
          inst,
          phone,
          altphone,
          uniq,
          type,
        
         };

         
     
               // Send data to the PHP backend using fetch
               fetch('https://hosteladventures.site/PHP/Opportunites/Attachment/Form.php', {
                 method: 'POST',
                 headers: {
                   'Content-Type': 'application/json'
                 },
                 body: JSON.stringify(loginData)
               })
                 .then(response => response.json())
                 .then(data => {
                   
                   if (data.message=='in') {
                     setFillin(false)
                     setBackid(true)
                   }
                
                 })
                 .catch(error => {
                   console.error('Error:', error);
                 });
      }
  
      else{
        alert('fill out all the fields')
      }
  
      
    }
    
    return (
      <div>
         <p className='fill_In'>Fill In this Application:</p>
  
         <input placeholder='name' onChange={(event) => setName(event.target.value)} />
         <input placeholder='course' onChange={(event) => setCourse(event.target.value)} />
         <input placeholder='institution' onChange={(event) => setInst(event.target.value)} />
         <input placeholder='Phone Number' onChange={(event) => setPhone(event.target.value)} />
         <input placeholder='alternative phone number' onChange={(event) => setAltphone(event.target.value)} />
         <div className='submit' onClick={submit}>Submit</div>
      </div>
    )
  }
export default Fill_in
